import $ from 'jquery';

jQuery(document).ready(function ($) {
  // Get the labels (stars)
  const stars = $('.rating .wpcf7-list-item-label');

  // Replace numbers with stars
  stars.text('★');

  // Assign an index to each radio button and its label
  stars.each(function (index) {
    $(this).prev().addBack().attr('data-index', index);
  });

  // Handle click on star
  stars.on('click', function () {
    $(this).prev('input').click();
  });

  // Highlight stars on hover
  stars
    .on('mouseover', function () {
      // Get the index of the hovered star
      const index = $(this).data('index');
      // Highlight this star and all previous stars
      stars.each(function () {
        if ($(this).data('index') <= index) {
          $(this).css('color', '#c44c4a');
        }
      });
    })
    .on('mouseout', function () {
      // Remove highlight from all stars
      stars.css('color', '#ccc');
      // Re-highlight selected star (if any) and all previous stars
      const index = $('.rating .wpcf7-list-item input:checked').data('index');
      stars.each(function () {
        if ($(this).data('index') <= index) {
          $(this).css('color', '#c44c4a');
        }
      });
    });

  // Highlight stars when one is clicked
  $('.rating .wpcf7-list-item input').on('change', function () {
    // Remove highlight from all stars
    stars.css('color', '#ccc');
    // Get the index of the selected star
    const index = $(this).data('index');
    // Highlight this star and all previous stars
    stars.each(function () {
      if ($(this).data('index') <= index) {
        $(this).css('color', '#c44c4a');
      }
    });
  });
});
